// import * as React from 'react'
// import { Modal } from '../../../Components/Modal'
// import { AdminIcon } from '../../../Icons/AdminIcon'
// import { BookingDto } from '../../../Types/BookingServiceTypes';
// import '../Adminbookings.css'
// interface ISendMailModal{
//     handleSendMailModalShow:(show:boolean) => void;
//     selectedBooking:BookingDto;
//     sendMaterial:()=>void;
// }
// export const SendMailModal = ({handleSendMailModalShow,selectedBooking,sendMaterial}:ISendMailModal) => {
//     const [emailFileAttachments,setEmailFileAttachments] = React.useState<File[]>([]);
//      const [materialSubject, setMaterialSubject] = React.useState("");
//       const [materialContent, setMaterialContent] = React.useState("");
// //       const handleEmailFileAttachemnts = (fileList: FileList | null) => {
// //     if (fileList) {
// //       const dataTransfer = new DataTransfer();
// //       Array.from(fileList).forEach((file) => dataTransfer.items.add(file));
// //       setEmailFileAttachments(dataTransfer);
// //     }
// //   }
// //   const removeFileAttachment = (fileName:string) =>{
// //      if (!emailFileAttachments) return;

// //   const newDataTransfer = new DataTransfer();

// //   Array.from(emailFileAttachments.files)
// //     .filter(file => file.name !== fileName)
// //     .forEach(file => newDataTransfer.items.add(file));
// //     setEmailFileAttachments(newDataTransfer);
// //   }
// const handleEmailFileAttachments = (fileList: FileList | null) => {
//     if (!fileList) return;
//     setEmailFileAttachments(Array.from(fileList));
// };

// const removeFileAttachment = (fileName: string) => {
//     setEmailFileAttachments(prev => prev.filter(f => f.name !== fileName));
// };
//   function truncateFilename(filename:string, maxLength = 30) {
//   if (filename.length <= maxLength) return filename;
//   const start = filename.slice(0, 15);
//   const end = filename.slice(-10);
//   return `${start}...${end}`;
// }
//     const handleSendMaterial = async():Promise<void> =>{
//         sendMaterial()
//     }
//     return(
//         <Modal onClose={() => handleSendMailModalShow(false)}>
//     <div style={{cursor:'pointer',width:35}} onClick={()=> handleSendMailModalShow(false)}>
//     <AdminIcon.CrossClose fill='#E16A54'/>
//     </div>
//     <form onSubmit={(e) => {
//       e.preventDefault();
//       handleSendMaterial();
//     }}>
//       <div className="sheet-header-container">
//         <h2 className="sheet-header-text">Skicka förberedelsematerial</h2>
//         <p className="sheet-header-paragraph">
//           Skicka förberedelsematerial till {selectedBooking?.name}
//         </p>
//       </div>

//       <div className="sheet-form-container">
//         <div>
//           <span className='custom-file-upload' >
//             <label htmlFor='custom-file-upload' className='' style={{cursor:'pointer'}}>
//               <AdminIcon.AttachClip width={25} height={25} fill='white'/>
//             </label>
//           <input
//             //ref={fileUploadRef}
//             onChange={(e) => {
//                 console.log(e)
//                 handleEmailFileAttachments(e.target.files)}}
//             className='file-input'
//             type="file"
//             id="custom-file-upload"
//             name="custom-file-upload"
//             accept="image/jpeg,image/png,image/gif,image/bmp,image/webp,image/tiff,image/svg+xml,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//             multiple />
//             <div style={{display:'flex',flexDirection:'column',gap:6,marginLeft:4}}>
//               {emailFileAttachments  && Array.from(emailFileAttachments).map((x,index) => {
//                 return (<div key={`${x.name}-${index}`} className='filename-pill'>
//                           <span className='filename-text'>
//                             {truncateFilename(x.name)}
//                           </span>
//                           <button type='button' className="filename-delete-button" onClick={()=> removeFileAttachment(x.name)} aria-label="Remove file">
//                             <AdminIcon.Trashcan fill='red' width={16} height={16}/>
//                             </button>
//                         </div>)
//               })}
//             </div>
//              </span>
             
//         </div>
//         <div>
//           <label htmlFor="subject" className="sheet-form-label">
//             Ämne
//           </label>
//           <input
//             required
//             id="subject"
//             type="text"
//             value={materialSubject}
//             onChange={(e) => setMaterialSubject(e.target.value)}
//             placeholder="Förberedelse inför vårt samtal"
//             className="sheet-form-input"
//           />
//         </div>

//         <div>
//           <label htmlFor="content" className="sheet-form-label">
//             Meddelande
//           </label>
//           <textarea
//             id="content"
//             required
//             rows={8}
//             value={materialContent}
//             onChange={(e) => setMaterialContent(e.target.value)}
//             placeholder="Skriv ditt meddelande här..."
//             className="sheet-form-input"
//           />
//         </div>

//         <button
//           type="submit"
//           className="sheet-form-submit-button"
//         >
//           {/* <Send className="h-4 w-4 mr-2" /> */}
//           <AdminIcon.Mail width={20} height={20} fill='white'/>
//           Skicka material
//         </button>
//       </div>
//     </form>
//   {/* </div> */}
//   </Modal>
//     )
// }
import * as React from 'react';
import { Modal } from '../../../Components/Modal';
import { apiRawPost } from '../../../DataService/apiClient';
import { AdminIcon } from '../../../Icons/AdminIcon';
import { BookingDto } from '../../../Types/BookingServiceTypes';

import '../Adminbookings.css';
import { toast } from 'react-toastify';
import { FileMetadata, FileService } from '../../../DataService/FileService';

import { SelectTrigger, SelectValue, SelectContent, SelectItem, Select } from '../../../Components/Select';

interface ISendMailModal {
    handleSendMailModalShow: (show: boolean) => void;
    selectedBooking: BookingDto;
    sendMaterial:()=>void;
}

export const SendMailModal = ({ handleSendMailModalShow, selectedBooking ,sendMaterial}: ISendMailModal) => {
    const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);
    const [existingFiles, setExistingFiles] = React.useState<FileMetadata[]>([]);
    const [selectedExistingFiles, setSelectedExistingFiles] = React.useState<FileMetadata[]>([]);
    const [selectedFileFilter,setSelectedFileFilter] = React.useState<string>('');
    const [materialSubject, setMaterialSubject] = React.useState('');
    const [materialContent, setMaterialContent] = React.useState('');
    const [saveFilesToDb,setSaveFilesToDb] = React.useState<boolean>(false);
    const [isSending, setIsSending] = React.useState(false);
    // Hämta befintliga filer vid mount
    React.useEffect(() => {
        FileService.GetAllFiles().then(files => {
            if (files) setExistingFiles(files);
        });
    }, []);

    const handleUploadFiles = (fileList: FileList | null) => {
        if (!fileList) return;
        setUploadedFiles(prev => [...prev, ...Array.from(fileList)]);
    };

    const removeUploadedFile = (fileName: string) => {
        setUploadedFiles(prev => prev.filter(f => f.name !== fileName));
    };

    const toggleExistingFile = (file: FileMetadata) => {
        console.log(file)
        setSelectedFileFilter(prev => prev == file.fileName ? 'Välj fil' : file.fileName)
        setSelectedExistingFiles(prev => {
            if (prev.some(f => f.id === file.id)) {
                console.log('kommer jag ens in här ')
                return prev.filter(f => f.id !== file.id);
            }
            return [...prev, file];
        });
    };

    function truncateFilename(filename: string, maxLength = 30) {
        if (filename.length <= maxLength) return filename;
        const start = filename.slice(0, 15);
        const end = filename.slice(-10);
        return `${start}...${end}`;
    }

    const handleSendMaterial = async () => {
        if (isSending) return;

        const formData = new FormData();
        formData.append('subject', materialSubject);
        formData.append('content', materialContent);
        formData.append('saveAttachmentsToDb',saveFilesToDb ? 'true' : 'false');
        formData.append('templateType','7');
        uploadedFiles.forEach(f => formData.append('newFiles', f));
        selectedExistingFiles.forEach(f => formData.append('existingFileIds', f.id.toString()));

        setIsSending(true);
        try {
            const res = await apiRawPost(`/EmailList/send-prep-material/${selectedBooking.id}`, formData);

            if (res.ok) {
                sendMaterial();
                handleSendMailModalShow(false);
                window.setTimeout(() => toast.success('Mail skickades!'), 0);
            } else {
                const text = await res.text();
                toast.warning(`Fel vid skick: ${text || res.status}`);
            }
        } catch (err) {
            console.log(err);
            toast.error('Något gick fel vid skick av mail');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Modal onClose={() => handleSendMailModalShow(false)}>
            <div style={{ cursor: 'pointer', width: 35 }} onClick={() => handleSendMailModalShow(false)}>
                <AdminIcon.CrossClose fill='hsl(var(--primary))' />
            </div>

            <form
                onSubmit={e => {
                    e.preventDefault();
                    handleSendMaterial();
                }}
            >
                <div className="sheet-header-container">
                    <h2 className="sheet-header-text">Skicka förberedelsematerial</h2>
                    <p className="sheet-header-paragraph">
                        Skicka förberedelsematerial till {selectedBooking?.name}
                    </p>
                </div>

                <div className="sheet-form-container">

                    {/* Nyuppladdade filer */}
                    <div>
                        <span className='custom-file-upload' >
                            <label htmlFor='custom-file-upload' className='' style={{cursor:'pointer'}}>
               <AdminIcon.AttachClip width={25} height={25} fill='white'/>
          </label>
                            <AdminIcon.AttachClip width={25} height={25} fill="white" />
                            <input
                                id="file-upload"
                                type="file"
                                accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                multiple
                                onChange={e => handleUploadFiles(e.target.files)}
                                className="file-input"
                            />
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginLeft: 4 }}>
                            {uploadedFiles.map(f => (
                                <div className="filename-pill" key={f.name}>
                                    <span className="filename-text">{truncateFilename(f.name)}</span>
                                    <button type="button" className="filename-delete-button" onClick={() => removeUploadedFile(f.name)}>
                                        <AdminIcon.Trashcan fill="red" width={16} height={16} />
                                    </button>
                                </div>
                            ))}
                           
                        </div>
                        </span>
                    </div>

                    {/* Befintliga filer */}
                    {existingFiles.length > 0 && (
                        <div style={{ marginTop: 20,width:'25%' }}>
                            <p>Välj befintlig fil att bifoga:</p>
                            {/* <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                {existingFiles.map(f => (
                                    <label key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedExistingFiles.some(s => s.id === f.id)}
                                            onChange={() => toggleExistingFile(f)}
                                        />
                                        {truncateFilename(f.fileName)}
                                    </label>
                                ))}
                            </div> */}
                            <Select
                    value={selectedFileFilter}
                onValueChange={(val) => {
                  const file = existingFiles.find((f) => f.id.toString() === val);
                  if (file) toggleExistingFile(file);
                }}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Välj fil" />
                </SelectTrigger>
                <SelectContent>
                  {existingFiles.map((f) => (
                    <SelectItem key={f.id} value={f.id.toString()} >
                     {selectedExistingFiles.some((s) => s.id === f.id) && "✔"} {f.fileName}  
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
                        </div>
                    )}

                    <div style={{ marginTop: 20 }}>
                        <label htmlFor="subject" className="sheet-form-label">Ämne</label>
                        <input
                            id="subject"
                            required
                            type="text"
                            value={materialSubject}
                            onChange={e => setMaterialSubject(e.target.value)}
                            placeholder="Förberedelse inför vårt samtal"
                            className="sheet-form-input"
                        />
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <label htmlFor="content" className="sheet-form-label">Meddelande</label>
                        <textarea
                            id="content"
                            required
                            rows={8}
                            value={materialContent}
                            onChange={e => setMaterialContent(e.target.value)}
                            placeholder="Skriv ditt meddelande här..."
                            className="sheet-form-input"
                        />
                    </div>
                    <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', gap: '1rem', alignItems: 'center', justifyContent:'space-between'}}>
                     <div style={{display:'flex', justifyContent:'flex-start'}}>   
                      <button type="submit" className="sheet-form-submit-button" disabled={isSending}>
                          {isSending ? (
                              <>
                                  <span className="sheet-button-spinner" aria-hidden="true" />
                                  Skickar...
                              </>
                          ) : (
                              <>
                                  <AdminIcon.Mail width={20} height={20} fill="white" />
                                  Skicka material
                              </>
                          )}
                      </button>
                     </div>
                     <div style={{display:'flex', alignItems:'center', gap:8, justifyContent:'flex-end', flexWrap:'wrap'}}>
                     <label>Spara uppladdade filer till databas.</label>
                     <input checked={saveFilesToDb} className='custom-checkbox' type='checkbox' onClick={() => setSaveFilesToDb(prev => !prev)}/>
                      </div>
                      </div>
                </div>
            </form>
        </Modal>
    );
};
